import { gql } from '@apollo/client'

import { FRAGMENT_ORDER_FIELDS } from './GetOrders'

export const GET_EMPLOYEE_ORDERS = gql`
  query getEmployeeOrders(
    $id: ID!
    $first: Int!
    $after: Int!
    $searchterm: String
    $filterByCaseType: [CaseItemType]
  ) {
    employee(id: $id) {
      id
      caseItems: caseitems(
        pagination: { after: $after, first: $first }
        searchterm: $searchterm
        orderBy: { field: id, order: DESC }
        filterByCaseType: $filterByCaseType
      ) {
        __typename
        totalCount
        pageInfo {
          __typename
          endCursor
          hasNextPage
        }
        caseItems {
          ...orderFields
        }
      }
    }
  }
  ${FRAGMENT_ORDER_FIELDS}
`
